import React, { useEffect, useState } from 'react'
import Header from '../../comps/Header'
import Footer from '../../comps/Footer'
import PageMainBanner from '../../comps/PageMainBanner'
import contact_support from "../../assets/images/contact-support.png"
import { get_blog_data, get_main_banner_section } from '../../api/Global'
import { Link } from 'react-router-dom'
import { IMG_BASE_URL } from '../../config/Base_Url_Config'
import More_Hosting from '../more_hosting/More_Hosting'

const Blog_List = () => {
    const [get_blog, set_Get_Blog] = useState([]);
    const [get_banner_list, set_Banner_List] = useState([]);

    useEffect(() => {
        const handle_get_blog = async () => {
            try {
                const response = await get_blog_data();
                set_Get_Blog(response?.data?.data?.blogs)
            }
            catch (error) {

            }
        }
        handle_get_blog();
    }, [])

    // <----------- render the main banner section ---------->
    useEffect(() => {
        const handle_get_main_banner_section = async () => {
            try {
                const response = await get_main_banner_section();
                set_Banner_List(response?.data?.data?.banners)
            } catch (error) {
                console.log("error", error)
            }
        }
        handle_get_main_banner_section();
    }, [])
    return (
        <div>
            {/* <--------- header section's ----------> */}
            <Header />
            <PageMainBanner heading="Blog" title={get_banner_list?.home_title}
                para={get_banner_list?.home_description} image={get_banner_list?.web_hosting_image ? `${IMG_BASE_URL}/${get_banner_list?.domain_image}` : { contact_support }} />
            <section className="relative">
                <div className="absolute inset-0 bg-gradient-to-b from-blue/50 via-transparent to-transparent" />
                <div className="relative py-10 md:py-18 sm:py-16 overflow-hidden" id="features">
                    <div className="absolute inset-0 -z-10">
                        <div className="absolute inset-0 bg-gradient-to-b from-black via-[#111111] to-black">
                        </div>
                        <div className="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-black/80 shadow-xl shadow-blue-900/10 ring-1 ring-blue-900/10">
                        </div>
                    </div>
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="md:flex justify-between items-center">
                            <div>
                                <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-950 border-1 border-blue-800/30 mb-4">
                                    <span className="text-sm font-medium text-blue-400"> Blog </span>
                                </div>
                                <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl"> Trending <span className="bg-gradient-to-r from-blue-700 to-blue-500 bg-clip-text text-transparent">
                                    Blogs</span></h2>
                                <p className="text-gray-400 mt-4 max-w-3xl">In today's competitive online landscape, every moment of website downtime can lead to
                                    lost opportunities, decreased revenue, and a
                                    damaged reputation. Uptime—the measure of your website's availability and functionality—is crucial for success.
                                    In this blog post, we’ll discuss the importance of uptime, its impact on performance, and strategies to maximize it.</p>
                            </div>
                            {/* <div class="mt-7 flex flex-col sm:flex-row gap-4 lg:justify-start justify-center">
                                <Link to="/blog-list" class="rounded-lg bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center">
                                    View All </Link>
                            </div> */}
                        </div>
                        <div className="mx-auto mt-10 lg:mt-16 lg:max-w-7xl">
                            <div className="grid sm:grid-cols-2 grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-3">
                                {
                                    get_blog?.map((get_blog_result) => {
                                        return (
                                            <div className="relative group">
                                                <div className="absolute -inset-2 bg-gradient-to-r from-blue-900/50 to-blue-800/50 rounded-2xl blur-xl opacity-0 group-hover:opacity-50 transition-all duration-500 -z-10">
                                                </div>
                                                <div className="relative backdrop-blur-xl bg-gray-900/50 rounded-xl p-4 h-full border-1 border-blue-900/10 hover:border-blue-500/20 transition-colors duration-300">
                                                    <div className="mb-6">
                                                        <div className="rounded-lg h-64 bg-blue-900/20 group-hover:bg-blue-800/50 transition-colors duration-300 p-0 overflow-hidden">
                                                            <img className="w-full object-cover rounded-lg" src={`${IMG_BASE_URL}/${get_blog_result?.image}`} alt="test" />
                                                        </div>
                                                    </div>


                                                    <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-950 border-1 border-blue-800/30 mb-4">
                                                        <span className="text-sm font-medium text-blue-400">
                                                            <i className="fa-solid fa-calendar-days mr-2" />
                                                            {new Date(get_blog_result?.created_at).toLocaleDateString("en-US", {
                                                                year: "numeric",
                                                                month: "long",
                                                                day: "numeric",
                                                            })}
                                                        </span>

                                                    </div>
                                                    <div className="text-lg line-clamp-1 font-semibold leading-7 text-white mb-3">{get_blog_result?.title}</div>
                                                    <div className="text-base leading-7 text-gray-400 line-clamp-2">{get_blog_result?.description}</div>
                                                    <div className="mt-7 flex flex-col sm:flex-row gap-4 lg:justify-start justify-center">
                                                        <Link to={`/blog-details/${get_blog_result?.id}`} className="rounded-lg bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center">
                                                            Read More </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                                {/* <div className="relative group">
                                    <div className="absolute -inset-2 bg-gradient-to-r from-blue-900/50 to-blue-800/50 rounded-2xl blur-xl opacity-0 group-hover:opacity-50 transition-all duration-500 -z-10">
                                    </div>
                                    <div className="relative backdrop-blur-xl bg-gray-900/50 rounded-xl p-4 h-full border-1 border-blue-900/10 hover:border-blue-500/20 transition-colors duration-300">
                                        <div className="mb-6">
                                            <div className="rounded-lg bg-blue-900/20 group-hover:bg-blue-800/50 transition-colors duration-300 p-5">
                                                <img className="h-[200px] mx-auto" src="assets/images/cloud.png" alt="test" />
                                            </div>
                                        </div>
                                        <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-950 border-1 border-blue-800/30 mb-4">
                                            <span className="text-sm font-medium text-blue-400"> <i className="fa-solid fa-calendar-days mr-2" /> January 25, 2025</span>
                                        </div>
                                        <div className="text-lg line-clamp-1 font-semibold leading-7 text-white mb-3">
                                            Understanding Cloud Hosting: Benefits and Use Cases</div>
                                        <div className="text-base leading-7 text-gray-400 line-clamp-2">As businesses and websites grow, the need for scalable, efficient, and reliable hosting solutions becomes more crucial than ever. Cloud hosting has revolutionized the industry, providing unmatched flexibility and performance...
                                        </div>
                                        <div className="mt-7 flex flex-col sm:flex-row gap-4 lg:justify-start justify-center">
                                            <button className="rounded-lg bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center">
                                                Read More </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="relative group">
                                    <div className="absolute -inset-2 bg-gradient-to-r from-blue-900/50 to-blue-800/50 rounded-2xl blur-xl opacity-0 group-hover:opacity-50 transition-all duration-500 -z-10">
                                    </div>
                                    <div className="relative backdrop-blur-xl bg-gray-900/50 rounded-xl p-4 h-full border-1 border-blue-900/10 hover:border-blue-500/20 transition-colors duration-300">
                                        <div className="mb-6">
                                            <div className="rounded-lg bg-blue-900/20 group-hover:bg-blue-800/50 transition-colors duration-300 p-5">
                                                <img className="h-[200px] mx-auto" src="assets/images/website-check.png" alt="test" />
                                            </div>
                                        </div>
                                        <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-950 border-1 border-blue-800/30 mb-4">
                                            <span className="text-sm font-medium text-blue-400"> <i className="fa-solid fa-calendar-days mr-2" /> January 23, 2025</span>
                                        </div>
                                        <div className="text-lg line-clamp-1 font-semibold leading-7 text-white mb-3">
                                            The Essential Checklist for Launching Your First Website</div>
                                        <div className="text-base leading-7 text-gray-400 line-clamp-2">In the competitive online
                                            Launching your first website is a thrilling milestone, but it can also be daunting. From selecting the perfect domain name to configuring hosting, there are several important steps to consider....</div>
                                        <div className="mt-7 flex flex-col sm:flex-row gap-4 lg:justify-start justify-center">
                                            <button className="rounded-lg bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-200 text-center">
                                                Read More </button>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*  */}
            <More_Hosting />
            <Footer />
            {/* <-------- footer section's -----------> */}
        </div>
    )
}

export default Blog_List
